import { z } from "zod";

const PERCENT = z.number().int().min(0).max(100);

export const RatioPolicySchema = z
  .object({
    ratio_shopee: PERCENT,
    ratio_lazada: PERCENT,
    ratio_tiktok: PERCENT,
  })
  .refine((r) => r.ratio_shopee + r.ratio_lazada + r.ratio_tiktok === 100, {
    message: "ratio.error.sum",
    path: ["ratio_tiktok"],
  });

export type RatioFormValues = z.infer<typeof RatioPolicySchema>;
